import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-over-loading',
  templateUrl: './over-loading.component.html',
  styleUrls: ['./over-loading.component.scss'],
})
export class OverLoadingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
